import { render, staticRenderFns } from "./aboutBanner.vue?vue&type=template&id=004577a1&scoped=true&"
import script from "./aboutBanner.vue?vue&type=script&lang=js&"
export * from "./aboutBanner.vue?vue&type=script&lang=js&"
import style0 from "./aboutBanner.vue?vue&type=style&index=0&id=004577a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004577a1",
  null
  
)

/* custom blocks */
import block0 from "./aboutBanner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports